// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Products from 'Containers/Products';
import Filters from 'Containers/Filters/Filters';
import ProductsProvider from 'Contexts/ProductsContext';
import FiltersProvider from 'Contexts/FiltersContext';
import ProductQuickViewModal from 'Containers/Products/ProductQuickViewModal';
import ViewProductsPage from 'Components/Products/ViewProducts';

const ProductsPage = memo(() => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('titles.productsPage') }</title>
      </Helmet>
      <ProductsProvider>
        <ProductQuickViewModal />
        <FiltersProvider>
          <ViewProductsPage>
            <Filters />
            <Products />
          </ViewProductsPage>
        </FiltersProvider>
      </ProductsProvider>
    </>
  );
});

ProductsPage.displayName = 'ProductsPage';

export default ProductsPage;
